module.exports = __webpack_public_path__ + "static/media/07.d62c8e27.png";